import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Channel} from '../models/channel';
import {ChannelService} from '../services/channel.service';

@Injectable({
    providedIn: 'root'
})
export class ChannelItemsResolver  {

    constructor(
        private _channelService: ChannelService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._channelService.getItemsAPI();
    }
}
